function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

const GEO_STORAGE_KEY = 'geo-popup-dismissed';

class GeoPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkUserLocation();
    this.setupEventListeners();
  }

  async checkUserLocation() {
    if (localStorage.getItem(GEO_STORAGE_KEY) || location.search.includes('shpxid')) {
      this.hidePopup();
      return;
    }

    const userCountry = await this.getCountry();
    const hreflangData = this.getHreflangData();

    const matchFound = this.checkCountryMatch(userCountry, hreflangData);

    if (!matchFound) {
      this.showPopup();
    } else {
      this.hidePopup();
    }
  }

  checkCountryMatch(userCountry, hreflangData) {
    const currentOrigin = window.location.href;

    const matchingHreflang = hreflangData.find(item =>
      item.countryCode === userCountry.toUpperCase()
    );

    if (!matchingHreflang) {
      return false;
    }

    const matchingUrl = new URL(matchingHreflang.href);
    const isOnCorrectSite = matchingUrl.href === currentOrigin;

    return isOnCorrectSite;
  }

  async getCountry() {
    const response = await fetch("https://get.geojs.io/v1/ip/country.json");
    const body = await response.json();
    return body.country;
  }

  showPopup() {
    this.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
  }

  hidePopup() {
    this.setAttribute("hidden", "");
    document.body.style.overflow = "auto";
    localStorage.setItem(GEO_STORAGE_KEY, "true");
  }

  getHreflangData() {
    const hreflangLinks = document.querySelectorAll('link[hreflang]');
    const hreflangData = [];

    hreflangLinks.forEach(link => {
      const hreflang = link.getAttribute('hreflang');
      const href = link.getAttribute('href');

      if (hreflang && href) {
        const countryCode = hreflang.includes('-')
          ? hreflang.split('-').pop().toUpperCase()
          : hreflang.toUpperCase();

        hreflangData.push({
          countryCode,
          href,
          hreflang
        });
      }
    });

    return hreflangData;
  }

  setupEventListeners() {

    let shpxidValue = '';

    if (sessionStorage.getItem('shpxid')) {
      shpxidValue = sessionStorage.getItem('shpxid');
    }

    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('shpxid')) {
      shpxidValue = currentUrl.searchParams.get('shpxid');
      sessionStorage.setItem('shpxid', currentUrl.searchParams.get('shpxid'));
    }

    currentUrl.searchParams.delete('shpxid');
    window.history.replaceState({}, '', currentUrl);

    const closeButtons = this.querySelectorAll("[data-close]");
    closeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.hidePopup();
      });
    });

    const geoTriggers = document.querySelectorAll("[data-geo-popup-trigger]");
    geoTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.showPopup();
      });
    });

    const hreflangData = this.getHreflangData();
    const countryLinks = this.querySelectorAll("[data-country-code]");
    countryLinks.forEach((link) => {
      const countryCode = link.getAttribute("data-country-code");

      const matchingHreflang = hreflangData.find(
        (item) => item.countryCode === countryCode.toUpperCase()
      );

      if (matchingHreflang) {
        const url = new URL(matchingHreflang.href);
        url.searchParams.set('shpxid', shpxidValue);
        const hrefWithShpxid = url.toString();

        link.setAttribute("href", hrefWithShpxid);
      }
    });
  }
}

customElements.define('geo-popup', GeoPopup);